import { flip, identity } from 'ramda'

const selectorBuilder = fn => (slice, createSelector) => {
  const sliced = selector => createSelector(slice, flip(identity), selector)

  return fn(sliced, createSelector)
}
export default selectorBuilder
